import AppHandler from '../stores/AppHandler';
import CardWallet from '../stores/CardWallet';

interface Stores {
  AppHandler: typeof AppHandler;
  CardWallet: typeof CardWallet;
}

function useStores(): Stores {
  return {
    AppHandler,
    CardWallet,
  };
}

export default useStores;
